export class Localization {
	Popispoli = null;
	Popisostatni = null;
	Formular = null;
	ChyboveHlasky = null;
}

export const localization = new Localization();
